import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // POS often runs offline — don't auto-refetch on focus.
      refetchOnWindowFocus: false,
      retry: (failureCount, error: unknown) => {
        // Don't retry 4xx; do retry 5xx and network.
        const status = (error as { response?: { status: number } })?.response?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
      staleTime: 60_000,
    },
  },
});
